<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <template v-if="currentView === 'allocate'">
          <allocation-entry
            :current-view="currentView"
            @switchView="switchView"
          />
        </template>
        <template v-else-if="currentView === 'daily'">
          <allocation-daily
            :current-view="currentView"
            @switchView="switchView"
          />
        </template>
        <template v-else-if="currentView === 'weekly'">
          <allocation-weekly
            :current-view="currentView"
            @switchView="switchView"
          />
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import AllocationEntry from './views/_Entry'
import AllocationDaily from './views/_Daily'
import AllocationWeekly from './views/_Weekly'

export default {
  name: 'DriverAllocations',
  components: {
    AllocationEntry,
    AllocationDaily,
    AllocationWeekly,
  },
  mixins: [],
  props: {},
  data() {
    return {
      currentView: 'allocate',
    }
  },
  computed: {},
  watch: {},
  created() {
  },
  methods: {
    switchView (viewType) {
      this.currentView = viewType
    }
  }
}
</script>
